import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";

import LogsHistoryTable from "../../../../components/ui/LogsHistoryTable";
import { APIAgentActivityLog } from "../../../../api";
import { IActivityLogsData } from "../../../../api/agentActivityLog/index.types";
import usePagination from "../../../../hooks/usePagination";
import { ISortBy } from "../../../../types";
import { ActiveFilter } from "../../../../components/ui/FilterSearch";
import { AGENT_ACTIVITY_LOG_API_URLS } from "../../../../api/agentActivityLog";

const AgentLogs = (): React.ReactElement => {
  const params: { id: string } = useParams();
  const id = +params.id;
  const pagination = usePagination();

  const [activeFilters, setActiveFilters] = useState<Record<string, ActiveFilter>>({});

  const [sortBy, setSortBy] = useState<ISortBy>({
    by: "log_time",
    order: false,
  });
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(0);
  const [logs, setLogs] = useState<IActivityLogsData[]>([]);

  const { error, isError } = useQuery({
    queryKey: [
      AGENT_ACTIVITY_LOG_API_URLS.getAgentActivityLog,
      pagination.limit,
      pagination.page,
      sortBy,
      id,
      activeFilters,
    ],
    queryFn: async ({ signal }) => {
      setLoading(true);
      const { data } = await APIAgentActivityLog.getActivityLogsRequest(
        {
          limit: pagination.limit,
          page: pagination.page,
          sortBy,
          admin_accounts_id: id,
          activeFilters,
        },
        signal
      );

      setCount(data.count);
      pagination.setCount(data.count);
      setLogs(data.logs);
      setLoading(false);
    },
  });

  useEffect(() => {
    if (isError && error) {
      setLoading(false);
    }
  }, [error, isError]);

  return (
    <div>
      <LogsHistoryTable
        logs={logs}
        loading={loading}
        count={count}
        handleSort={[sortBy, setSortBy]}
        pagination={pagination}
        setActiveFilters={setActiveFilters}
        filterOptions={[
          { key: "code", label: "Code" },
          { key: "customer", label: "Customer" },
          { key: "log_time", label: "Date", type: "date" },
        ]}
      />
    </div>
  );
};

export default AgentLogs;
